import { IconObject, ICONS, Notification } from '@bob/library'
import { formatDate, formatDateMonthYear } from '@websrc/App/Helpers/formatting'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import { styles } from 'leds'
import React from 'react'

export interface ProductInfoBackorderProps {
  productDetails: {
    product_status: ReturnType<typeof mapProductPage>['product_details']['product_status']
    back_order_date: ReturnType<typeof mapProductPage>['product_details']['back_order_date']
    valid_from_date: ReturnType<typeof mapProductPage>['product_details']['valid_from_date']
  }
  show: boolean
}

export const ProductInfoBackorder = ({ productDetails, show }: ProductInfoBackorderProps) => {
  const t = useStaticText()
  const locale = useLocale()
  let icon: IconObject = ICONS.WARNING

  const { product_status, back_order_date, valid_from_date } = productDetails

  let backorderLabel = ''

  if (product_status === 'E2' && valid_from_date) {
    backorderLabel = t.ecom.preorder_with_date.replace(
      '{date}',
      formatDateMonthYear(valid_from_date, true)
    )
    icon = ICONS.ROCKET
  } else if (product_status === 'E3' && back_order_date) {
    backorderLabel = t.ecom.out_of_stock.replace('{0}', formatDate(back_order_date))
  }

  if (!backorderLabel || !show || locale !== 'en-us') {
    return null
  }

  return (
    <Notification
      className={styles({ marginBottom: 25 })}
      icon={icon}
      prominence={'high'}
      type={'warning'}
    >
      {backorderLabel}
    </Notification>
  )
}
